import React, { useContext, useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ISwapVolumeByDex } from '../../api/interfaces'
import { ThemeContext } from '../../App'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { colors } from '../../const'
import { useChartData } from '../../hooks/useChartData'

async function getDexSwapVolumePCTConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_dex_swap_volume', timeframe)) as ISwapVolumeByDex[]

	const thorswapData = chartData.filter((row) => row.LABEL === 'THORSwap')
	const thorwalletData = chartData.filter((row) => row.LABEL === 'THORWallet')
	const trustwalletData = chartData.filter((row) => row.LABEL === 'Trustwallet')
	const asgardexData = chartData.filter((row) => row.LABEL === 'Asgardex')
	const shapeshiftData = chartData.filter((row) => row.LABEL === 'ShapeShift')
	const othersData = chartData.filter((row) => row.LABEL === 'Others')
	const ledgerData = chartData.filter((row) => row.LABEL === 'Ledger')
	const vultisigData = chartData.filter((row) => row.LABEL === 'Vultisig')
	const bitgetData = chartData.filter((row) => row.LABEL === 'Bitget')
	const tcSwapData = chartData.filter((row) => row.LABEL === 'TCSwap')
	let series1,
		series2,
		series3,
		series4,
		series5,
		series6,
		series7,
		series8,
		series10,
		series12: {
			x: number
			y: number
		}[] = []
	if (timeframe === '1w' || timeframe === '1d') {
		series1 = thorswapData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series2 = thorwalletData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series3 = trustwalletData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series4 = asgardexData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series5 = shapeshiftData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series6 = othersData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series7 = bitgetData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series8 = ledgerData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})

		series10 = vultisigData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
		series12 = tcSwapData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_PCT_OF_TOTAL }
		})
	} else {
		//(timeframe === '1m')
		series1 = thorswapData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series2 = thorwalletData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series3 = trustwalletData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series4 = asgardexData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series5 = shapeshiftData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series6 = othersData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series7 = bitgetData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series8 = ledgerData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})

		series10 = vultisigData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
		series12 = tcSwapData.map((element: ISwapVolumeByDex) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_PCT_OF_TOTAL }
		})
	}

	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'THORSwap',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[0]}`,
			unitSymbol: '%',
			barGroup: 'positive'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'TrustWallet',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[1]}`,
			unitSymbol: '%',
			barGroup: 'positive'
		},
		{
			data: series8,
			strokeWidth: 2,
			name: 'Ledger',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[2]}`,
			unitSymbol: '%',
			barGroup: 'positive'
		},

		{
			data: series2,
			strokeWidth: 2,
			name: 'THORWallet',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[3]}`,
			unitSymbol: '%',
			barGroup: 'positive'
		},
		{
			data: series7,
			strokeWidth: 2,
			name: 'BitgetWallet',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[4]}`,
			unitSymbol: '%',
			barGroup: 'positive'
		},
		{
			data: series5,
			strokeWidth: 2,
			name: 'ShapeShift',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[5]}`,
			unitSymbol: '%',
			barGroup: 'positive'
		},
		{
			data: series4,
			strokeWidth: 2,
			name: 'Asgardex',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[6]}`,
			unitSymbol: '%',
			barGroup: 'positive'
		},
		{
			data: series10,
			strokeWidth: 2,
			name: 'Vultisig',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[7]}`,
			unitSymbol: '%',
			barGroup: 'positive'
		},
		{
			data: series12,
			strokeWidth: 2,
			name: 'TCSwap',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[9]}`,
			unitSymbol: '%',
			barGroup: 'positive'
		},
		{
			data: series6,
			strokeWidth: 2,
			name: 'Others',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[8]}`,
			unitSymbol: '%',
			barGroup: 'positive'
		}
	]

	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const DexSwapVolumePCT = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getDexSwapVolumePCTConfig, '1w')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Percentage of the Total Swap Volume by Affiliate"
			chartDesc="Swap volume generated through each affiliate as a percentage of total affiliate volume."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="7f7629d7-28e9-4d53-8ea8-9135104e48e8"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			hasDays={false}
			sortByValueDesc={true}
		/>
	)
}

export default DexSwapVolumePCT
